import { Chip, ChipProps } from '@mui/material'
import { RequestStatus } from '../enums/RequestStatus'
import { useTranslation } from 'react-i18next'

export interface ActionRequestStatusChipProps extends Omit<ChipProps, 'label' | 'color'> {
  status: RequestStatus
}

export default function ActionRequestStatusChip({
  status,
  ...props
}: ActionRequestStatusChipProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('common')

  /**
   * The color of the chip.
   */
  const color =
    status === RequestStatus.APPROVED
      ? 'success'
      : status === RequestStatus.REJECTED
        ? 'error'
        : 'warning'

  /**
   * The label of the chip.
   */
  const label = t(`RequestStatus.${status}`)

  return <Chip label={label} color={color} {...props} />
}
